import PptxGenJS from "pptxgenjs";

export const thankYouPage = (pptx: PptxGenJS, data: any) => {
    const slide = pptx.addSlide();
    slide.background = { color: '000000' };

    // Top Header Bar
    slide.addShape('rect', {
        x: 0,
        y: 0,
        w: '100%',
        h: 0.8,
        fill: { color: 'FFFFFF' },
        line: { type: 'none' }
    });

    slide.addImage({
        path: '/Access-Holdings-Logo.jpg',
        x: 0.5,
        y: 0.2,
        w: 1.3,
        h: 0.45
    });

    // Main "Thank You!" Text
    slide.addText('Thank You!', {
        x: 0,
        y: 4.8,
        w: '100%',
        h: 1.0,
        fontSize: 44,
        bold: true,
        color: 'FFFFFF',
        align: 'center',
        valign: 'middle'
    });

    // Orange accent bar under "Thank You!"
    slide.addShape('rect', {
        x: 2.13, // Centered (8.27 - 4) / 2
        y: 5.6,
        w: 4.0,
        h: 0.1,
        fill: { color: 'FF6600' },
        line: { type: 'none' }
    });

    // Footer at the bottom of A4 (Height 11.69)
    slide.addShape('rect', {
        x: 0,
        y: 11.0,
        w: '100%',
        h: 0.6,
        fill: { color: 'FF6600' },
        line: { type: 'none' }
    });

    slide.addText('360-Degree Feedback Individual Report — Confidential', {
        x: 0,
        y: 11.15,
        w: '100%',
        h: 0.3,
        fontSize: 10,
        color: 'FFFFFF', // Changed to white as per image
        align: 'center'
    });
};
